(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "f3fc891d8bcf44fd3af4c6f795e81641dad0c6e8"
};